import { isMarketingOrigin, marketingPageLocation } from './measurement';

/** Never send tenant slugs, record IDs, query strings or private page titles. */
export function performanceLocation(href: string): string | null {
  if (!isMarketingOrigin(href, true)) return null;
  const url = new URL(href);
  const publicLocation = marketingPageLocation(href);
  if (publicLocation) {
    return new URL(new URL(publicLocation).pathname, url.origin).href;
  }
  if (/^\/home(?:\/|$)/.test(url.pathname)) {
    return `${url.origin}/app`;
  }
  return null;
}
